export default __webpack_public_path__ + "static/media/profile.5eb74e2d.png";